<button
  type="button"
  class="sz-action-row"
  [class.sz-action-row--primary]="kind() === 'primary'"
  [class.sz-action-row--secondary]="kind() === 'secondary'"
  [class.sz-action-row--tertiary]="kind() === 'tertiary'"
  [class.is-disabled]="disabled()"
  [disabled]="disabled()"
  (click)="onClick()">
  @if (kind() === 'primary') {
    <span class="sz-action-row__strip" aria-hidden="true"></span>
  }
  <sz-ic-circle
    class="sz-action-row__ic"
    [size]="kind() === 'primary' ? 'md' : 'sm'"
    [accent]="kind() === 'primary' ? 'lime' : 'ghost'">
    <sz-icon [name]="icon()" [size]="kind() === 'primary' ? 18 : 16" />
  </sz-ic-circle>
  <span class="sz-action-row__body">
    <span class="sz-action-row__title">
      {{ title() }}
      @if (soon()) {
        <sz-pill variant="outline">Soon</sz-pill>
      }
    </span>
    @if (sub()) {
      <span class="sz-action-row__sub">{{ sub() }}</span>
    }
  </span>
  <sz-icon class="sz-action-row__arrow" name="arrow-right" [size]="14" />
</button>
